<ng-container *ngFor="let descItem of desc.descItems">
  <span *ngIf="!(descItem.hidden$ | async)" class="desc_{{ descItem.color }}">
    {{ descItem.text }}
  </span>
</ng-container>
